<div class="fifth-block vpy-6">
    <div class="text-center" data-aos="zoom-in">
        <div class="Obviously-Wide home-heading vmt-3">The More You Interact,</div>
        <div class="Obviously-Wide home-heading vmt-1 vmb-5">The Better Your Recommendations</div>
    </div>

    <div class="row text-center justify-content-center vpy-3 mx-0">
        <div class="colsm-12 col-6 row mx-0 px-0 justify-content-end">
            <div class="col-6 arrow-img mx-0 ps-0 vpr-1">
                <img class="love-arrow  w-100" src="./assets/img/home/fifth-block/love-arrow.png">
                <div class="d-flex flex-wrap">
                    <div class="love-text vmb-1">Love it? <br> Give it a heart!</div>
                    <div class="light-text m-auto">We'll send you more styles. <br> you love!</div>
                </div>
            </div>
            <div class="col-6 float-end gif-img" [class.vmb-5]="isMobile">
                <img class="float-end loved-reaction" src="./assets/img/home/fifth-block/loved-reaction.png">
                <img class="float-end love-it w-100" src="./assets/img/home/fifth-block/love-it.gif">
            </div>
        </div>

        <div class="colsm-12 col-6 row mx-0 px-0">
            <div class="col-6 vmt-6 vpt-6 gif-img">
                <img class="float-end dislike-reactions" src="./assets/img/home/fifth-block/dislike-reactions.png">
                <img class="float-end dislike w-100" src="./assets/img/home/fifth-block/dislike.gif">
            </div>
            <div class="col-6 {{ isMobile ? '' : 'mt-3' }} arrow-img mx-0 ps-0 vpr-1">
                <div class="d-flex flex-wrap">
                    <div class="light-text vmb-1">Not your style - noted! We'll send you new styles.</div>
                    <div class="dislike-text">Don't like it? <br> Give it a thumbs down</div>
                </div>
                <img class="dislike-arrow w-100 float-end" src="./assets/img/home/fifth-block/dislike-arrow.png">
            </div>
        </div>
    </div>
</div>